export enum CharityScreeningVersion {
  V1 = 'V1',
}
